/* eslint-disable react/jsx-props-no-spreading */
import {
  TextField,
  Autocomplete,
  Typography,
  Grid2 as Grid,
  Divider,
} from "@mui/material";
import type { FormData } from "./template-advanced-config";
import TemplateValidationRules from "./template-validation-rules";
import { DATA_TYPES } from "../constants";

interface TemplateConfigFieldsProps {
  formData: FormData;
  onFormDataChange: React.Dispatch<React.SetStateAction<FormData>>;
}

const TemplateConfigFields = ({
  formData,
  onFormDataChange,
}: TemplateConfigFieldsProps) => {
  return (
    <>
      <Grid size={12}>
        <Typography variant="body2" fontWeight={600} sx={{ mt: 3, mb: 0.5 }}>
          Configuration
        </Typography>
        <Divider sx={{ mb: 1 }} />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }}>
        <TextField
          label="Minimum Length"
          type="number"
          value={formData.minLength}
          onChange={(e) =>
            onFormDataChange({
              ...formData,
              minLength: Number.parseInt(e.target.value, 10) || 0,
            })
          }
          size="small"
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 4 }}>
        <TextField
          label="Maximum Length"
          type="number"
          value={formData.maxLength}
          onChange={(e) =>
            onFormDataChange({
              ...formData,
              maxLength: Number.parseInt(e.target.value, 10) || 0,
            })
          }
          size="small"
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 4 }}>
        <Autocomplete
          options={DATA_TYPES}
          getOptionLabel={(option) => option.description}
          value={formData.dataType}
          onChange={(_e, newValue) =>
            onFormDataChange({ ...formData, dataType: newValue })
          }
          size="small"
          renderInput={(params) => <TextField {...params} label="Data Type" />}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TemplateValidationRules
          formData={formData}
          setFormData={onFormDataChange}
        />
      </Grid>
    </>
  );
};

export default TemplateConfigFields;
